import React, { useMemo } from 'react';
import { Input, Form, Button } from 'antd';
import type { LoginService } from '../../../service/authorization';
import { useLogin } from '../actions';

export interface MobileFormProps {
  Mobile: React.FunctionComponent<any>,
  CodeInput: React.FunctionComponent<any>,
  Form: React.FunctionComponent<any>,
  CodeGetter: (Component?: React.FunctionComponent<any>) => React.FunctionComponent<any>,
}

const useMobileFactory = (service: LoginService): MobileFormProps => {
  const { fields } = service;
  const StaticForm: React.FunctionComponent = (props: any) => {
    const [form] = Form.useForm();
    const { children, ...restProps } = props;
    const onFinish = useLogin(service);
    return (
      <Form {...restProps} form={form} onFinish={onFinish}>
        {children}
      </Form>
    )
  };
  const Mobile: React.FunctionComponent = (props: any) => {
    const { label, message, ...inputProps } = props;
    return (
      <Form.Item
        // label属性是展示用的属性，与数据处理无关，故暴露
        label={label}
        // name属性是用的属性，与数据展示无关，故隐藏
        name="mobile"
        rules={[{ required: true, message: message || `请输入${label}` }]}
      >
        <Input {...inputProps} />
      </Form.Item>
    );
  };
  // TODO: 合成一个输出组件
  const CodeInput: React.FunctionComponent = (props: any) => {
    const { label, message, ...inputProps } = props;
    return (
      <Form.Item
        label={label}
        name="validator"
        rules={[{ required: true, message: message || `请输入${label}` }]}
        noStyle
      >
        <Input.Password {...inputProps} />
      </Form.Item>
    );
  };
  const CodeGetter = (Component: React.FunctionComponent = Button) => (
    (props: any) => {
      const { onClick = () => {}, ...restProps } = props;
      return (
        <Component
          {...restProps}
          onClick={(e: Event) => {
            // TODO: service.getValidator
            if (typeof onClick === 'function') {
              onClick(e);
            }
          }}
        />
      );
    }
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => ({ CodeGetter, CodeInput, Mobile, Form: StaticForm }), [fields]);
};

export default useMobileFactory;
